<template>
  <div class="content-main page-postcard-form">
    <div class="deliver-info">

      <div class="form-title">明信片收件信息登记表</div>
      <div class="form-hint">填表以后，我们会审核表单信息，审核通过以后，会在你指定的日期前寄出明信片，例如：期望2030年9月收到明信片，我们会在2030年9月第一个周末寄出你的明信片。在此之前，请耐心等待，你提交的表单信息，我们都会收到并查看。</div>

      <div class="info-items">

        <!-- <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>寄件类型</span></div>
          <van-radio-group v-model="parcel.receiver_type">
            <van-radio class="radio-receiver" name="1">寄给自己</van-radio>
            <van-radio class="radio-receiver" name="2">寄给他人</van-radio>
          </van-radio-group>
        </div> -->

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>寄件人姓名</span></div>
          <div><van-field v-model="parcel.sender_name" placeholder="请填写寄件人姓名" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>寄件人联系电话</span></div>
          <div><van-field v-model="parcel.sender_phone" placeholder="请填写寄件人联系电话" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>收件人名称</span></div>
          <div><van-field v-model="parcel.receiver_name" placeholder="请填写收件人名称" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>收件人联系电话</span></div>
          <div><van-field v-model="parcel.receiver_phone" placeholder="请填写收件人联系电话" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>收件地址</span><span class="input-hint">（请填写长期有效的地址，并具体到门牌号！)</span></div>
          <!-- <div><span class="input-hint">错误1：XX省XX市XX县XX镇，没有具体门牌号，可能会无法派送</span></div> -->
          <!-- <div><span class="input-hint">提示：地址需长期有效，例如期望5年后寄出，但现在填的是XX学校，五年后你可能离开这个学校了，就会无法派送</span></div> -->

          <van-field
          clickable
          :value="parcel.district"
          placeholder="请选择省份/城市/区县/乡镇街道"
          @click="showPickerDistricts = true"
          />
          <van-popup class="popup-districts" v-model="showPickerDistricts" round position="bottom">
            <van-picker
            class="picker-districts"
            show-toolbar
            :columns="columnsDistricts"
            value-key="name"
            :title="districtsPickerTitle"
            @cancel="onCancelDistricts"
            @confirm="onConfirmDistricts"
            />
          </van-popup>

          <div><van-field v-model="parcel.address" type="textarea" rows="1" autosize placeholder="请填写详细地址，如：小区、楼栋、门牌号等" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>期望收信时间</span><span class="input-hint">（我们会在你指定月份的第一个周末寄出明信片）</span></div>
          <div @click="showDatePopup()"><van-field v-model="schedule" placeholder="年 — 月" left-icon="calender-o" disabled/></div>
          <van-popup v-model="showDatePicker">
            <van-datetime-picker v-model="postDate" type="year-month" :min-date="minDate"
              :formatter="formatter" @cancel="hideDatePopup()" @confirm="showDateConfirmDialog()"/>
          </van-popup>

          <van-dialog v-model="showDialog" title="期望收信时间再次提醒" show-cancel-button
            cancelButtonText="修改年月" cancelButtonColor="#1989fa"
            @confirm="confirmDateConfirmDialog()" @cancel="cancelDateConfirmDialog()">
            <div class="date-dialog-msg"><span>是否期望收信时间为：</span><span class="dialog-date">{{ getDialogDate() }}</span></div>
          </van-dialog>

        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>你发布的抖音视频截图(或快手/视频号)</span><span class="input-hint">（需全屏截图，视频20个赞即可免费寄出明信片）</span></div>
          <div v-if="parcel.douyin_screen" class="screen-line flex-box">
            <div class="flex-box"><img class="douyin_screen" :src="parcel.douyin_screen"><span class="picname">{{ resetDouyinPicName() }}</span></div>
            <van-icon class="icon-delete" name="delete" @click="deleteDouyinScreen()" />
          </div>
          <van-uploader v-if="!parcel.douyin_screen" :after-read="uploadDouyinScreen">
            <div class="upload-line flex-box">
              <van-icon class="icon-add-image" name="plus" :max-size="10 * 1024 * 1024" @oversize="imageOversize()" /><div>点击上传图片，图片大小限制10MB以内</div>
            </div>
          </van-uploader>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>你的抖音号ID/快手ID/视频号ID</span><span class="input-hint">（用于审核视频）</span></div>
          <div><van-field v-model="parcel.douyin_id" placeholder="请填写你的抖音号ID/快手ID/视频号ID" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>你的微信号</span><span class="input-hint">（方便与你联系）</span></div>
          <div><van-field v-model="parcel.wechat" placeholder="请填写你的微信号" /></div>
        </div>

        <div class="info-item">
          <div class="item-title"><span class="star-dot">•</span><span>选择你的寄语</span><span class="input-hint">（选择的寄语内容会被写在纸质明信片上寄出）</span></div>
          <div class="options-mails">
            <div class="option-mail flex-box" v-for="mail in mails" :key="mail.id">
              <img v-if="parcel.info_id == mail.id" @click="uncheckMail(mail.id)" class="icon-check" src="http://static.zhishishijian.com/icon-checked-20211101.png">
              <img v-if="parcel.info_id != mail.id" @click="checkMail(mail.id)" class="icon-check" src="http://static.zhishishijian.com/icon-uncheck-20211101.png">
              <div class="mail-content">To: {{mail.receiver}}<br/>{{mail.content}}<br/>From: {{mail.sender}}</div>
            </div>
            <div class="no-mails-hint" v-if="mails.length == 0">
              你还没有提交过寄语哦～<br/>
              <span class="create-mail-link" @click="goMessageCreate()">点此提交寄语</span>
            </div>
          </div>
        </div>

        <div class="info-item">
          <div class="item-title"><span>备注信息</span><span class="input-hint">（可以填任意备注信息，也可以不填。）</span></div>
          <div><van-field v-model="parcel.remark" type="textarea" rows="2" autosize placeholder="请填写备注信息" /></div>
        </div>

      </div>

      <div class="btn-submit" @click="submit()">提交信息</div>

    </div>

  </div>
</template>

<script>
import { Toast, Field, Popup, Picker, Loading, Dialog, Icon, RadioGroup, Radio, Uploader, DatetimePicker} from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [DatetimePicker.name]: DatetimePicker
  },
  data(){
    return {
      parcel: {
        sender_name: "",
        sender_phone: "",
        receiver_name: "",
        receiver_phone: "",
        district: "",
        address: "",
        province: "",
        remark: "",
        douyin_screen: '',
        douyin_id: '',
        wechat: '',
        info_id: '',
        schedule: '',
        pid: ''
      },
      schedule: '',
      postDate: this.getThreeYearsDate(),
      minDate: this.getThreeYearsDate(),
      showDatePicker: false,
      hiddenDatePopup: true,
      imageUptoken: '',
      mails: [],
      showDialog: false,
      fieldDistricts: '',
      showPickerDistricts: false,
      columnsDistricts: [],
      districtsPickerTitle: '选择省份',
      districtsPickerType: 1,
      provinceTmp: '',
      provinces: [],
      select_info_id: ""
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    showDatePopup(){
      this.showDatePicker = true
    },
    hideDatePopup(){
      this.showDatePicker = false
    },
    showDateConfirmDialog(){
      this.showDialog = true
    },
    cancelDateConfirmDialog(){
      this.showDialog = false
    },
    confirmDateConfirmDialog(){
      this.showDialog = false
      this.convertPostDate()
    },
    getDialogDate(){
      let time = new Date(this.postDate)
      let date = `${time.getFullYear()}年${time.getMonth() + 1}月`
      return date
    },
    convertPostDate(){
      let time = new Date(this.postDate)
      this.schedule = `${time.getFullYear()}年${time.getMonth() + 1}月`
      this.showDatePicker = false
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    imageOversize(){
      Toast('图片大小不能超过10MB');
    },
    uploadDouyinScreen(file) {
      // console.log(file)
      this.uploadImage(file)
    },
    uploadImage(file){
      let picName = `postcard-douyin-${(new Date()).valueOf()}-oz6zo-${file.file.name}`
      let data = new FormData();
      data.append("file", file.file);
      data.append("key", picName);
      data.append("token", this.imageUptoken);
      this.$qiniu.post("/", data, res => {
        if(res.key){
          console.log(res)
          let img_domain = "http://static.huiyiji520.com/"
          this.parcel.douyin_screen = `${img_domain}${res.key}`
        }
      })
    },
    resetDouyinPicName(){
      let picName = this.parcel.douyin_screen.split('-oz6zo-')[1].slice(0, 15)
      if(picName.length > 15){
        return (picName + '...')
      }else{
        return picName
      }
    },
    deleteDouyinScreen(){
      this.parcel.douyin_screen = ''
    },
    getImageUptoken(){
      this.$api.get('/momentbox/get_img_uptoken', {openid: this.$store.state.userinfo.openid}, res => {
        if(res.code == 200){
          this.imageUptoken = res.uptoken
        }
      })
    },
    getSelfMails(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/momentbox/get_userself_mails', {openid: openid, page: 1}, res => {
        if(res.code == 200){
          this.mails = res.infos
          if(this.mails.length > 0){
            this.parcel.info_id = this.mails[0].id
          }
        }
      })
    },
    checkMail(id){
      this.parcel.info_id = id
      // this.select_info_id = id
      console.log('checkMail: ' + id)
    },
    uncheckMail(id){
      this.parcel.info_id = ''
      // this.select_info_id = ""
      console.log('uncheckMail: ' + id)
    },
    goMessageCreate(){
      let openid = this.$store.state.userinfo.openid
      this.handleRouter("/mail_create")
    },
    getParcelStatus(){
      this.$api.get('/momentbox/get_parcel_status', {openid: this.$store.state.userinfo.openid}, res => {
        if(res.code == 200){
          this.imageUptoken = res.uptoken
          this.parcel = res.parcel
          this.mails = res.infos
          // if(this.mails.length > 0){
          //   this.parcel.info_id = this.mails[0].id
          // }
        }
      })
    },
    getParcelDetail(){
      let id = this.$route.params.id
      this.$api.get('/momentbox/get_parcel_detail_v2', {id: id}, res => {
        if(res.code == 200){
          this.imageUptoken = res.uptoken
          this.parcel = res.parcel
          this.mails = res.infos
          this.postDate = new Date(res.parcel.schedule * 1000)
          this.convertPostDate()
          // this.provinceTmp = res.parcel.province
        }
      })
    },
    getNextMonthDate(){
      let date = new Date()
      date.setMonth(date.getMonth() + 1)
      return date
    },
    getThreeYearsDate(){
      let date = new Date()
      date.setYear(date.getFullYear() + 3)
      return date
    },
    submit(){
      if(!this.parcel.sender_name.trim()){
        Toast('请填写寄件人姓名')
        return;
      }
      if(!this.parcel.sender_phone.trim()){
        Toast('请填写寄件人手机号码')
        return;
      }
      if(!this.parcel.receiver_name.trim()){
        Toast('请填写收信人名称')
        return;
      }
      if(!this.parcel.receiver_phone.trim()){
        Toast('请填写收信人手机号码')
        return;
      }
      if(!this.parcel.province){
        Toast('请选择收件地区')
        return;
      }
      if(!this.parcel.address.trim()){
        Toast('请填写详细收信地址')
        return;
      }
      if(!this.schedule.trim()){
        Toast('请填写期望收信时间')
        return;
      }
      if(!this.parcel.douyin_screen.trim()){
        Toast('请上传抖音视频截图')
        return;
      }
      if(!this.parcel.douyin_id.trim()){
        Toast('请填写你的抖音号ID')
        return;
      }
      if(!this.parcel.wechat.trim()){
        Toast('请填写你的微信号')
        return;
      }
      if(!this.parcel.info_id.trim()){
        Toast('请选择寄语')
        return;
      }
      if(!this.parcel.remark.trim()){
        this.parcel.remark = "无"
      }
      let openid = this.$store.state.userinfo.openid
      let parcel = this.parcel
      let schedule = Date.parse(this.postDate) / 1000

      this.$api.post('/momentbox/modify_parcel_by_user_v2', {
        pid: parcel.pid, info_id: parcel.info_id, douyin_screen: parcel.douyin_screen, douyin_id: parcel.douyin_id, wechat: parcel.wechat,
        sender_name: parcel.sender_name, sender_phone: parcel.sender_phone, receiver_name: parcel.receiver_name, receiver_phone: parcel.receiver_phone,
        district: parcel.district, address: parcel.address, province: parcel.province, remark: parcel.remark,
        schedule: schedule
      }, res => {
        if(res.code == 200){
          Toast('已提交明信片收件信息')
          // this.parcel.status = 1
          this.$router.replace("/mails_records")
        }
      })

    },
    goEdit(){
      this.handleRouter(`/parcel_revise_douyin/${this.parcel.pid}`)
    },
    getProvinces(){
      this.$api.get('/district/get_provinces', {}, res => {
        if(res.code == 200){
          this.columnsDistricts = res.provinces
          this.provinces = res.provinces
        }
      })
    },
    onConfirmDistricts(obj){
      if(this.districtsPickerType == 1){
        this.$api.get('/district/get_cities_by_province', {provinceid: obj.code}, res => {
          if(res.code == 200){
            this.columnsDistricts = res.cities
            this.districtsPickerTitle = obj.name
            this.districtsPickerType = 2
            this.provinceTmp = obj.code
          }
        })
      }else if(this.districtsPickerType == 2){
        this.$api.get('/district/get_counties_by_city', {cityid: obj.code}, res => {
          if(res.code == 200){
            this.columnsDistricts = res.counties
            this.districtsPickerTitle += obj.name
            this.districtsPickerType = 3
          }
        })
      }else if(this.districtsPickerType == 3){
        this.$api.get('/district/get_towns_by_county', {countyid: obj.code}, res => {
          if(res.code == 200){
            this.columnsDistricts = res.towns
            this.districtsPickerTitle += obj.name
            this.districtsPickerType = 4
          }
        })
      }else if(this.districtsPickerType == 4){
        this.fieldDistricts = this.districtsPickerTitle + obj.name
        this.parcel.district = this.districtsPickerTitle + obj.name
        this.parcel.province = this.provinceTmp
        this.showPickerDistricts = false
        this.districtsPickerType = 1
        this.districtsPickerTitle = "选择省份"
        this.columnsDistricts = this.provinces
      }
    },
    onCancelDistricts(){
      this.showPickerDistricts = false
      this.districtsPickerType = 1
      this.districtsPickerTitle = "选择省份"
      this.columnsDistricts = this.provinces
    }
  },
  mounted(){
    // this.getParcelStatus()
    this.getProvinces()
    this.getParcelDetail()
  }
}
</script>

<style scoped>
.content-main{text-align:left;padding-bottom:75px;}
.deliver-info .form-title{padding-top:30px;padding-left:30px;color:#333;font-size:30px;}
.deliver-info .form-hint{margin:0px 30px;margin-top:8px;padding:15px;font-size:23px;color:#333;border:1px solid #e2e2e2;}
.info-items{padding:30px;padding-bottom:0px;}
.info-item{margin-bottom:40px;font-size:24px;}
.info-item .item-title{color:#333;font-weight:bold;}
.info-item .input-hint{font-weight:normal;font-size:22px;}
.info-item .star-dot{color:#fe4900;margin-right:8px;}
.info-item .radio-receiver{margin-top:15px;font-size:22px;}
.info-item .van-field{width:100%;font-size:22px;background:#fafafa;padding:8px;color:#999;border-radius:8px;border:1px solid #d2d6de;margin-top:15px;margin-bottom:15px;}
.van-popup{width:60%;}
.popup-districts{width:100%;}
.date-dialog-msg{padding:30px 30px 45px 30px;font-size:24px;text-align:center;}
.dialog-date{color:#fe4900;font-weight:bold;}
.screen-line{border:1px solid #bfbfbf;margin-top:15px;padding:8px;justify-content:space-between;}
.screen-line .douyin_screen{width:53px;height:53px;display:block;margin-right:15px;}
.screen-line .picname{font-size:22px;color:#808080;}
.screen-line .icon-delete{color:#fe4900;font-size:30px;}
.upload-line{border:1px dashed #bfbfbf;padding:15px;color:#999;font-size:22px;margin-top:15px;}
.upload-line .icon-add-image{color:#333;font-size:30px;margin-right:8px;}
.options-mails{margin-top:20px;}
.options-mails .no-mails-hint{text-align:center;font-size:22px;}
.options-mails .create-mail-link{color:#0769cb;border-bottom:1px solid #0769cb;font-size:23px;}
.option-mail{margin-bottom:20px;align-items:flex-start;}
.option-mail .icon-check{width:30px;margin-right:30px;}
.option-mail .mail-content{font-size:22px;color:#666;border:1px dashed #333;padding:8px;}
.hints{color:#999;font-size:15px;padding:15px;padding-top:0px;}
.btn-submit{background:#00a65a;color:#fff;font-size:24px;margin:0px auto;width:80%;padding:20px;border-radius:8px;text-align:center;}
.daojie{width:225px;height:225px;margin-top:30px;margin-bottom:15px;}
.wait-delivery{padding:30px;text-align:center;padding-top:150px;font-size:21px;color:#595959;}
.img-success{width:120px;height:120px;margin:0 auto;margin-bottom:40px;}
.wait-delivery .wait-hint{text-align:left;font-size:28px;text-indent:2em;margin-bottom:8px;}
.wait-delivery .wait-title{font-weight:bold;color:#333;font-size:32px;text-align:center;margin-bottom:23px;}
.check-success .wait-hint{text-align:center;}
.wait-delivery .corp-wechat-hint{color:#bc4031;font-weight:bold;}
.wait-delivery .unsubscribe-hint{font-size:21px;}
.deliver-com{font-weight:bold;}
.deliver-no{font-weight:bold;}
.edit-postcard-link{text-align:center;margin-top:30px;margin-bottom:30px;}
.edit-postcard-link .link-text{font-size:28px;color:#0769cb;border-bottom:1px solid #0769cb;padding-bottom:8px;}
</style>
